<template>
  <div class="component-container"><h1 class="component-text">Our tours</h1></div>
</template>

<script>
export default {
  name: 'AppComponent',
  props: {},
}
</script>

<style scoped>
.component-container {
  display: flex;
  position: relative;
}
.component-text {
  color: var(--dl-color-gray-black);
  font-size: 3rem;
}
@media(max-width: 991px) {
  .component-text {
    text-align: center;
  }
}
</style>
